import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import notifications from "@zendesk/knowledge-redux/lib/reducers/notifications";
import categories from "./categories";
import category from "./category";
import sections from "./sections";
import section from "./section";
import articles from "./articles";

export default history =>
  combineReducers({
    router: connectRouter(history),
    categories,
    sections,
    category,
    section,
    articles,
    notifications,
  });



// WEBPACK FOOTER //
// ./src/reducers/index.js